import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import TmReportDetails from "../components/reports/TmReportDetails";

export const TmReportDetailsPage = () => {
  return (
    <MasterLayout>
      <TmReportDetails />
    </MasterLayout>
  );
};
